"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeAccessToken = void 0;
var decodeToken_1 = require("./decodeToken");
var decodeAccessToken = function (args) { return (0, decodeToken_1.decodeToken)(args); };
exports.decodeAccessToken = decodeAccessToken;
